module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAA5klEQVRIS7XVuw3CMBAAUJ8UeQNWoKKCDWigYwcXUUaKUngHOmjYACoqVmADK9JFFyEExvaZS5wuVvx0v9iglFJd1+2qqroZY570Ln2stYu+79d1XZ+hbds9ABwR8aG13kpxQp1zFwBYIuIBPhZWiHiX4CEDKO0peGzvCEvxVEBv+F+cy/ILzsU5lJwfmMNz0Cgcw2n9NVLsBAUjjjV0jASARZMRh3Bay531ZMR+SWaD/UbNUopQ9yc3LzVS4nHL2ZjzTflfOicK/wJgDyEJyp2K5Q76YlcTpUS41voqve+8smyapjkNwKO4JJVG8AcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/guanbi.png
// module id = fmWA
// module chunks = 1